import { Component, Input } from "@angular/core"
import { ColorCodeService } from "../../../services/color-code.service"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-mfr-card",
    templateUrl: "./mfr-card.component.html",
    styleUrls: ["./mfr-card.component.less"],
})
export class MfrCardComponent extends CardComponent {
    constructor(protected colorCodeService: ColorCodeService, public userService: UserService) {
        super(colorCodeService, userService)
    }
}
